import React from "react";
import { ResetPasswordProps } from "./ResetPassword.types";
import { AuthMe, IUser, ResetPassword } from "@grassrootly/api";
import useBaseRequest from "../../api/BaseRequest";
import { useNavigation } from "@react-navigation/native";
import { useAlert } from "@grassrootly/rn-core";

export function useResetPassword({ access_token, refresh_token }: ResetPasswordProps["authParams"]) {
  const [authUser, setAuthUser] = React.useState<IUser | null>(null);
  const navigation = useNavigation();
  const { danger, success } = useAlert();

  const { loading, execute: getUser } = useBaseRequest(AuthMe, {
    onCompleted: (data) => {
      if (!data) {
        setAuthUser(null);
        danger({ message: "Invalid token" });
        navigation.reset({ index: 0, routes: [{ name: "login" }] });
      } else {
        setAuthUser(data);
      }
    },
  });

  const { loading: reseting, execute: resetPassword } = useBaseRequest(ResetPassword, {
    onCompleted: (data) => {
      if (!data) {
        danger({ message: "Something went wrong updating your password" });
        return;
      }
      success({ message: "Password set successfully. Poceed to login." });
      setTimeout(() => {
        navigation.reset({ index: 0, routes: [{ name: "login" }] });
      }, 500);
    },
  });

  React.useEffect(() => {
    if (!access_token || !refresh_token) {
      danger({ message: "Invalid token" });
      navigation.reset({ index: 0, routes: [{ name: "login" }] });
      return;
    }
    getUser({ access_token: access_token });
  }, [access_token]);

  const onSubmit = ({ newPassword }: { newPassword: string; repeatNewPassword: string }) => {
    resetPassword({ password: newPassword, access_token, refresh_token });
  };

  return { onSubmit, loading, authUser, reseting };
}
